import type { Id, ToastOptions, TypeOptions } from "react-toastify";
import { toast } from "react-toastify";
import { toastContainerId } from "./ToastContainer";
import { ToastItem } from "./ToastItem";
import type { IToastColor, IToastContent } from "./types";

export class Toast {
  static info(content: IToastContent, toastOptions?: ToastOptions): Id {
    return createToast(content, {
      ...toastOptions,
      type: "info",
    });
  }

  static success(content: IToastContent, toastOptions?: ToastOptions): Id {
    return createToast(content, {
      ...toastOptions,
      type: "success",
    });
  }

  static warning(content: IToastContent, toastOptions?: ToastOptions): Id {
    return createToast(content, {
      ...toastOptions,
      type: "warning",
    });
  }

  static error(content: IToastContent, toastOptions?: ToastOptions): Id {
    return createToast(content, {
      ...toastOptions,
      type: "error",
    });
  }
}

/** react-toastify's type → the kit's semantic colour (`error` is `danger`). */
function getToastColor(type: TypeOptions | undefined): IToastColor {
  switch (type) {
    case "success":
      return "success";
    case "warning":
      return "warning";
    case "error":
      return "danger";
    default:
      return "info";
  }
}

function createToast(content: IToastContent, toastOptions?: ToastOptions): Id {
  return toast(
    ({ closeToast }: { closeToast: () => void }) => {
      return (
        <ToastItem
          title={content.title}
          message={content.message}
          onDismiss={closeToast}
          color={getToastColor(toastOptions?.type)}
        />
      );
    },
    {
      ...toastOptions,
      containerId: toastContainerId,
    },
  );
}
